"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/createClass.js"));
/**
 * 存储流程设计相关参数
 */
var BpmData = exports.default = /*#__PURE__*/function () {
  function BpmData() {
    (0, _classCallCheck2.default)(this, BpmData);
    this.controls = []; // 设计器控件
    this.init();
  }
  return (0, _createClass2.default)(BpmData, [{
    key: "init",
    value: function init() {
      this.controls = [{
        action: 'create.start-event',
        title: '开始'
      }, {
        action: 'create.intermediate-event',
        title: '中间'
      }, {
        action: 'create.end-event',
        title: '结束'
      }, {
        action: 'create.exclusive-gateway',
        title: '网关'
      }, {
        action: 'create.task',
        title: '任务'
      }, {
        action: 'create.user-task',
        title: '用户任务'
      }, {
        action: 'create.user-sign-task',
        title: '会签任务'
      }, {
        action: 'create.subprocess-expanded',
        title: '子流程'
      }, {
        action: 'create.data-object',
        title: '数据对象'
      }, {
        action: 'create.data-store',
        title: '数据存储'
      }, {
        action: 'create.participant-expanded',
        title: '扩展流程'
      }, {
        action: 'create.group',
        title: '分组'
      }];
    }

    //  获取控件配置信息
  }, {
    key: "getControl",
    value: function getControl(action) {
      var result = this.controls.filter(function (item) {
        return item.action === action;
      });
      return result[0] || {};
    }
  }]);
}();